import React from 'react';
import { useSelector } from 'react-redux';
import { UserCardLite } from 'ha/components.legacy/UserCardLite';
import { getAdvertiserLegacy, getShowReportBtn } from '../selectors';

export const ListingAdvertiserCardLite = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const advertiser = useSelector(getAdvertiserLegacy);
  const showReportBtn = useSelector(getShowReportBtn);

  return (
    <UserCardLite user={advertiser} showReportBtn={showReportBtn}>
      {children}
    </UserCardLite>
  );
};
